import React from 'react'
import './Navbar.css'

function Navbar() {
    return (
        <div className="App">
            <img className = "App.logo" src="https://img.icons8.com/color/144/000000/facebook-messenger.png"/>
            <h1>Facebook Messenger Clone🚀<br/><small>Created by Brian Kibet</small><span role='img'>😗📕</span></h1>
              {/* <small><i> Welcome {username}</i></small> */}
        </div>
    )
}

export default Navbar
